import _ from "lodash";
import { assetsPath } from "../../utils";

const baseAssetUrl = assetsPath("laguna-seaside-residences");

const heroShotImg1 = `${baseAssetUrl}/images/gallery/hero-shot/1.jpg`;
const heroShotImg2 = `${baseAssetUrl}/images/gallery/hero-shot/2.jpg`;
const heroShotImg3 = `${baseAssetUrl}/images/gallery/hero-shot/3.jpg`;
const heroShotImg4 = `${baseAssetUrl}/images/gallery/hero-shot/4.jpg`;

const aerial1 = `${baseAssetUrl}/images/gallery/images/aerial/1.jpg`;
const aerial2 = `${baseAssetUrl}/images/gallery/images/aerial/2.jpg`;

const commonArea1 = `${baseAssetUrl}/images/gallery/images/common-area/1.jpg`;
const commonArea2 = `${baseAssetUrl}/images/gallery/images/common-area/2.jpg`;

const exterior1 = `${baseAssetUrl}/images/gallery/images/exterior/1.jpg`;
const exterior2 = `${baseAssetUrl}/images/gallery/images/exterior/2.jpg`;

const interior1 = `${baseAssetUrl}/images/gallery/images/interior/1.jpg`;
const interior2 = `${baseAssetUrl}/images/gallery/images/interior/2.jpg`;
const interior3 = `${baseAssetUrl}/images/gallery/images/interior/3.jpg`;
const interior4 = `${baseAssetUrl}/images/gallery/images/interior/4.jpg`;
const interior5 = `${baseAssetUrl}/images/gallery/images/interior/5.jpg`;
const interior6 = `${baseAssetUrl}/images/gallery/images/interior/6.jpg`;
const interior7 = `${baseAssetUrl}/images/gallery/images/interior/7.jpg`;
const interior8 = `${baseAssetUrl}/images/gallery/images/interior/8.jpg`;

const lifestyle1 = `${baseAssetUrl}/images/gallery/images/lifestyle/1.jpg`;
const lifestyle2 = `${baseAssetUrl}/images/gallery/images/lifestyle/2.jpg`;
const lifestyle3 = `${baseAssetUrl}/images/gallery/images/lifestyle/3.jpg`;
const lifestyle4 = `${baseAssetUrl}/images/gallery/images/lifestyle/4.jpg`;
const lifestyle5 = `${baseAssetUrl}/images/gallery/images/lifestyle/5.jpg`;

const videoSource = `${baseAssetUrl}/images/gallery/video/Laguna Seaside3 slide image - lingual version.mp4`;

const video = {
  en: videoSource,
  ru: videoSource,
  cn: videoSource,
};

const heroShot = [
  { image: heroShotImg1 },
  { image: heroShotImg2 },
  { image: heroShotImg3 },
  { image: heroShotImg4 },
];

const categories = [
  {
    id: 1,
    name: "All Images",
  },
  {
    id: 2,
    name: "Aerial",
  },
  {
    id: 3,
    name: "Exterior",
  },
  {
    id: 4,
    name: "Interior",
  },
  {
    id: 5,
    name: "Common Area",
  },
  {
    id: 6,
    name: "Lifestyle",
  },
];

const images = [
  {
    categoryId: 2,
    name: "Aerial – 1",
    image: aerial1,
  },
  {
    categoryId: 2,
    name: "Aerial – 2",
    image: aerial2,
  },
  {
    categoryId: 3,
    name: "Building 1",
    image: exterior1,
  },
  {
    categoryId: 3,
    name: "Building 2",
    image: exterior2,
  },
  {
    categoryId: 4,
    name: "1 Bedroom - Living room",
    image: interior1,
  },
  {
    categoryId: 4,
    name: "2 Bedroom - Living room",
    image: interior2,
  },
  {
    categoryId: 4,
    name: "2 Bedroom - Lanai",
    image: interior3,
  },
  {
    categoryId: 4,
    name: "2 Bedroom - Section",
    image: interior4,
  },
  {
    categoryId: 4,
    name: "3 Bedroom - Living room",
    image: interior5,
  },
  {
    categoryId: 4,
    name: "3 Bedroom - Lanai",
    image: interior6,
  },
  {
    categoryId: 4,
    name: "2 bedroom - garden",
    image: interior7,
  },
  {
    categoryId: 4,
    name: "3 bedroom - garden",
    image: interior8,
  },
  {
    categoryId: 5,
    name: "Rooftop Pool",
    image: commonArea1,
  },
  {
    categoryId: 5,
    name: "Rooftop Facilities",
    image: commonArea2,
  },
  {
    categoryId: 6,
    name: "Lifestyle",
    image: lifestyle1,
  },
  {
    categoryId: 6,
    name: "Lifestyle",
    image: lifestyle2,
  },
  {
    categoryId: 6,
    name: "Lifestyle",
    image: lifestyle3,
  },
  {
    categoryId: 6,
    name: "Lifestyle",
    image: lifestyle4,
  },
  {
    categoryId: 6,
    name: "Lifestyle",
    image: lifestyle5,
  },
];

const image360 = null;

export default {
  heroShot,
  categories,
  images: _.map(images, (image) => {
    return {
      ...image,
      category: _.find(categories, { id: image.categoryId }),
    };
  }),
  video,
  image360,
  view360: [
    {
      id: "AERIAL",
      type: "virtual-tour",
      src: `${baseAssetUrl}/360/aerial/index.html`,
      list: [],
    },
    {
      id: "INTERIOR",
      type: "virtual-tour",
      src: `${baseAssetUrl}/360/interior/index.html`,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/data/LagunaSeasideResidences/gallery.js